import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {FormControl} from '@angular/forms';

import {RequestParameters} from '../../models/request-parameters/parameter.model';
import {CallCenter} from '../../../call-center/call-center.model';
import {CallCenterService} from '../../../call-center/call-center.service';

@Component({
  selector: 'app-call-center-autocomplete',
  templateUrl: './call-centers-autocomplete.component.html',
  styleUrls: ['./call-centers-autocomplete.component.scss']
})
export class CallCentersAutocompleteComponent implements OnInit {

  @Input('callCenterFormControl') callCenterFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onCallCenterSelected: EventEmitter<CallCenter> = new EventEmitter<CallCenter>();

  callCenters: Observable<any> = new Observable<any>();
  callCenterLoading: boolean = true;
  callCenterParameters: RequestParameters = new RequestParameters();

  @ViewChild('autoParent') autoParent: ElementRef;

  constructor(private callCenterService: CallCenterService) {
    this.updateCallCenter();
  }

  ngOnInit() {
  }

  onSelectCallCenter() {
    this.onCallCenterSelected.emit(this.callCenterFormControl.value);
  }


  displayCallCenter (callCenter: CallCenter) {
    if (callCenter !== null) {
      return callCenter.name;
    }
  }

  filterCallCenters (filterInput: string = '') {
    if (this.callCenterParameters.searchString !== filterInput) {
      this.callCenterParameters.searchString = filterInput;
      this.updateCallCenter();
    }
  }

  updateCallCenter () {
    this.callCenterLoading = true;
    this.callCenters = this.callCenterService.getCallCenters(this.callCenterParameters)
      .map(
        (response) => {
          this.callCenterLoading = false;
          return response.result;
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/call-centers-autocomplete/call-center-autocomplete.component.ts